(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();
	var documentHeight = $(document).height();

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var messageHeight = $('.important-message').outerHeight() || 0;
	var topmenuHeight = $('.top-menu-wrp').outerHeight() || 0;
	var top_messageHeight = messageHeight + topmenuHeight;
	var sitemenuHeight = $('.site-menu-wrp').outerHeight() || 0;
	var headerlogoHeight = $('.header-logo-wrp').outerHeight() || 0;
	var logo_messageHeight = messageHeight + headerlogoHeight;
	var navbarHeight = messageHeight + headerlogoHeight + 48;
	var navbarHeightBig = messageHeight + headerlogoHeight + 21;

	$(window).scroll(function(event){
	    didScroll = true;
	});

	setInterval(function() {
	    if (didScroll) {
	        hasScrolled();
	        didScroll = false;
	    }
	}, 10);

	function hasScrolled() {
	    var st = $(this).scrollTop();

	    // Make sure they scroll more than delta
	    if(Math.abs(lastScrollTop - st) <= delta)
	        return;

	    // If they scrolled down and are past the navbar, add class .nav-up.
	    // This is necessary so you never see what is "behind" the navbar.
			if (st < logo_messageHeight){
				if(windowWidth > 1365) {
					$('#site-header').css('top','0px');
					$('#main').css('padding-top',navbarHeightBig);
				} else if(windowWidth > 1023) {
					$('#site-header').css('top','0px');
					$('#main').css('padding-top',navbarHeight);
				}
				else {
					$('#site-header').css('top','0px');
					$('#main').css('padding-top',logo_messageHeight);
				}
			}
	    else if (st > lastScrollTop && st > 5){
	        // Scroll Down
	       if(windowWidth > 1023) {
						$('#site-header').css('top',-navbarHeight-100);
					}
					else {
						$('#site-header').css('top',-logo_messageHeight);
					}
	    } else {
	        // Scroll Up
					if (st + windowHeight < documentHeight) {
						if(windowWidth > 1023) {
				  		$('#site-header').css('top',-top_messageHeight);
				  	}
						else {
							$('#site-header').css('top',-messageHeight);
						}
					}
	    }
	    lastScrollTop = st;
	}

	/* Document ready functions */
	$(document).ready(function (){

		setTimeout(function () {
			// Get Window Width and Height on resize
			windowWidth = $(window).outerWidth();
			windowHeight = $(window).height();
			documentHeight = $(document).height();
			messageHeight = $('.important-message').outerHeight() || 0;
			topmenuHeight = $('.top-menu-wrp').outerHeight() || 0;
			top_messageHeight = messageHeight + topmenuHeight;
			sitemenuHeight = $('.site-menu-wrp').outerHeight() || 0;
			headerlogoHeight = $('.header-logo-wrp').outerHeight() || 0;
			logo_messageHeight = messageHeight + headerlogoHeight;
			messageHeight = $('.important-message').outerHeight() || 0;
			headerlogoHeight = $('.header-logo-wrp').outerHeight() || 0;
			logo_messageHeight = messageHeight + headerlogoHeight;

			navbarHeightBig = messageHeight + headerlogoHeight + sitemenuHeight + 10;
			navbarHeight = messageHeight + headerlogoHeight + sitemenuHeight - 24;

			if(windowWidth > 1365) {
				$('#main').css('padding-top',navbarHeightBig);
				$('.header-search').css('margin-top',messageHeight);
				$('.lang-selector').css('margin-top',messageHeight);
			} else if(windowWidth > 1023) {
				$('#main').css('padding-top',navbarHeight);
				$('.header-search').css('margin-top',messageHeight);
				$('.lang-selector').css('margin-top',messageHeight);
			} else {
				$('#main').css('padding-top',logo_messageHeight);
				$('.header-search').css('margin-top',messageHeight);
				$('.lang-selector').css('margin-top',messageHeight);
			}
		}, 200);

	});

	$(window).resize(function () {

		setTimeout(function () {
			// Get Window Width and Height on resize
			windowWidth = $(window).outerWidth();
			windowHeight = $(window).height();
			documentHeight = $(document).height();
			messageHeight = $('.important-message').outerHeight() || 0;
			topmenuHeight = $('.top-menu-wrp').outerHeight() || 0;
			top_messageHeight = messageHeight + topmenuHeight;
			sitemenuHeight = $('.site-menu-wrp').outerHeight() || 0;
			headerlogoHeight = $('.header-logo-wrp').outerHeight() || 0;
			logo_messageHeight = messageHeight + headerlogoHeight;
			messageHeight = $('.important-message').outerHeight() || 0;
			headerlogoHeight = $('.header-logo-wrp').outerHeight() || 0;
			logo_messageHeight = messageHeight + headerlogoHeight;
			navbarHeight = messageHeight + headerlogoHeight + sitemenuHeight + 48;
			navbarHeightBig = messageHeight + headerlogoHeight + sitemenuHeight + 21;
			if(windowWidth > 1365) {
				$('#main').css('padding-top',navbarHeightBig);
				$('.header-search').css('margin-top',messageHeight);
				$('.lang-selector').css('margin-top',messageHeight);
			} else if(windowWidth > 1023) {
				$('#main').css('padding-top',navbarHeight);
				$('.header-search').css('margin-top',messageHeight);
				$('.lang-selector').css('margin-top',messageHeight);
			} else {
				$('#main').css('padding-top',logo_messageHeight);
				$('.header-search').css('margin-top',messageHeight);
				$('.lang-selector').css('margin-top',messageHeight);
			}
		}, 200);


	});

})(jQuery);
